import styled from 'styled-components';

const FlexEndWrapper = styled.div`
	align-items: flex-end;
	display: flex;
`;

export default FlexEndWrapper;
